import { useMemo } from 'react';

import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';

import { ShowbieFeatureName } from '../../showbie-common/config/showbieFeatureVersions';
import { useShowbieFeatureSupport } from './useShowbieFeatureSupport';

/**
 * Hook that provides feature support checks for the current context.
 * In Socrative, all features are supported.
 * In Assessments, checks version requirements.
 */
export function useFeatureSupportCheck() {
  const applicationContext = useTeacherApplicationContext();
  const isQuizLibraryDownloadExportSupported = useShowbieFeatureSupport(
    ShowbieFeatureName.QuizLibraryDownloadExport
  );

  return useMemo(() => {
    const isSocrative =
      applicationContext === TeacherApplicationContext.Socrative;

    return {
      canDownloadAndExportQuiz:
        isSocrative || isQuizLibraryDownloadExportSupported,
    };
  }, [applicationContext, isQuizLibraryDownloadExportSupported]);
}
